import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const WebhookConfigList = () => {
  const fetchUrl = `${API_DOMAIN}${API_ROUTES.webhookConfig}`;

  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Destination URL', value: 'destination_url' },
    { label: 'Active', value: item => item.is_active ? 'Yes' : 'No' },
    { label: 'Last Response Code', value: 'last_response_code' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/webhook-config/details/${id}`;
  };

  return (
    <div>
      <h1>Webhook Configurations</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default WebhookConfigList;
